import { environment } from '../../../../../environments/environment'
import * as moment_ from 'moment'
import { MatDatepickerInputEvent } from '@angular/material/datepicker'
import { Component, OnInit } from '@angular/core'
import { DemandSelect, ListDemandSchedule } from '../../../../../app/models/Demand'
import { UserAdmin } from '../../../../../app/models/UserAdmin'
import { RankingEvaluator } from '../../../../../app/models/RankingEvaluator'
import { NotificationService } from '../../../../../app/services/notification.service'
import { Router } from '@angular/router'
import { SchedulingService } from '../../../../../app/services/scheduling.service'
import { AllPinsFromScheduleAppraisal, ScheduleAppraisalDetails, ScheduleTreeDetails } from '../../../../../app/models/Appraisal'
import { CompanyService } from '../../../../../app/services/company.service'
import { ViewValidation } from '../../../../_helpers/ViewValidation'
import { InventoryScheduleList } from 'src/app/models/Inventory'
import MarkerClusterer from '@google/markerclustererplus'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { Region } from 'src/app/models/Region'
import { RegionsService } from 'src/app/services/regions.service'
import { InventoryService } from 'src/app/services/inventory.service'

declare var ol: any

@Component({
	selector: 'app-steps',
	templateUrl: './steps.component.html'
})
export class StepsComponent implements OnInit {

	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()

	public ViewValidation: ViewValidation = new ViewValidation()

	public moduleSchedule: 'demand' | 'inventory'

	public demand: Array<ListDemandSchedule> = []
	public inventorys: Array<InventoryScheduleList> = []
	public demandSelected: DemandSelect
	public allRegions: Array<Region> = []

	private options = {
		maxZoom: 20,
		styles: [{
			height: 53,
			url: 'https://arbolink-app.s3.amazonaws.com/2d1b-aa82-c1.png',
			width: 53
		},
		{
			height: 56,
			url: 'https://arbolink-app.s3.amazonaws.com/ee44-8e61-c2.png',
			width: 56
		},
		{
			height: 66,
			url: 'https://arbolink-app.s3.amazonaws.com/9f6f-98ec-c3.png',
			width: 66
		},
		{
			height: 78,
			url: 'https://arbolink-app.s3.amazonaws.com/0402-3f54-c4.png',
			width: 78
		},
		{
			height: 90,
			url: 'https://arbolink-app.s3.amazonaws.com/f1fa-e98f-c5.png',
			width: 90
		}
		]
	}
	public viewMarkersClusterided: boolean = true
	public isLoading: boolean = false
	public enableButton: boolean = false
	public isAdmin: boolean = false
	public companyIsActive: boolean = false
	public hasCheckEvaluationScheduling = false
	public hasCheckTreeEvaluated: boolean = false
	public hasCheckSolicitations: boolean = false
	public openAgrupar: boolean = false
	public agendamentos: boolean = false
	public photoFromCarouselEnable: boolean = false
	public enableGroupButton: boolean = false
	public openTab2: boolean = false
	public openTab1: boolean = true
	public enablebuttonAssignTree: boolean = false
	public retractMap: boolean = false
	public viewAllRegionsInMap: boolean = true
	public mediaUrlSelected: string = ''

	public carousels = {
		demand: {
			pages: 0,
			pageNow: 1,
			arrowLeftEnable: false,
			arrowRightEnable: true
		},
		tree: {
			pages: 0,
			pageNow: 1,
			arrowLeftEnable: false,
			arrowRightEnable: true
		},
		group: {
			pages: 0,
			pageNow: 1,
			arrowLeftEnable: false,
			arrowRightEnable: true
		}
	}

	public evaluators: Array<RankingEvaluator> = []
	public evaluatorSelected: RankingEvaluator
	public appraisalSelected: ScheduleAppraisalDetails
	public treeSelected: ScheduleTreeDetails

	public current_day_now: string = moment_().format('YYYY-MM-DD 00:00:00.000')
	public current_day: string
	public date: Date = new Date()

	public myMap: google.maps.Map
	public markers: Array<google.maps.Marker> = []
	public polygonsDelimitAllRegions: Array<google.maps.Polygon> = []
	public regionInfoWindow = new google.maps.InfoWindow()
	public allPinsFromMaps: AllPinsFromScheduleAppraisal
	public markerCluster: MarkerClusterer
	public treeSelectedMarkerIndex: number = 0
	public markersIndexAssigns: Array<number> = []

	public imageGallery: Array<object> = []
	public imageGallerySelected: Array<object> = []
	public cameFromMapSchedule = Boolean(localStorage.getItem('cameFromScheduleMap'))

	constructor(
		private router: Router,
		public notificationService: NotificationService,
		private schedulingService: SchedulingService,
		private companyService: CompanyService,
		private readonly regionsService: RegionsService,
		private readonly inventoryService: InventoryService
	) { }

	public async ngOnInit(): Promise<void> {

		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		const demand = localStorage.getItem('demand')
		const inventorys = JSON.parse(localStorage.getItem('inventories'))

		let permissionToCreate: boolean = false

		this.isLoading = true

		if (inventorys) {
			if (this.cameFromMapSchedule) {
				this.inventoryService.getOnlySelectedInventories(this.companyId, inventorys, 0, inventorys.length + 1, 'data', 'desc').subscribe(response => {
					this.inventorys = response

					permissionToCreate = Boolean(this.sessionUser.assignments.includes('INVENTORY_SCHEDULE_CREATE'))

					this.enableButton = Boolean(permissionToCreate || this.isAdmin)
					this.moduleSchedule = 'inventory'
					this.selectDemand(this.inventorys[0].idMongo)
				})
			} else {
				this.inventorys = inventorys

				permissionToCreate = Boolean(this.sessionUser.assignments.includes('INVENTORY_SCHEDULE_CREATE'))

				this.enableButton = Boolean(permissionToCreate || this.isAdmin)
				this.moduleSchedule = 'inventory'
				this.selectDemand(this.inventorys[0].idMongo)
			}
		} else {
			if (this.cameFromMapSchedule) {
				const demandsIds: Array<string> = JSON.parse(demand)

				this.schedulingService.getOnlySelectedDemand(this.companyId, demandsIds, 0, demandsIds.length + 1, 'data', 'desc').subscribe(response => {
					this.demand = response

					permissionToCreate = Boolean(this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_CREATE'))
					this.enableButton = Boolean(permissionToCreate || this.isAdmin)
					this.moduleSchedule = 'demand'
					this.selectDemand(this.demand[0].idMongo)
				})
			} else {
				this.demand = JSON.parse(demand)

				permissionToCreate = Boolean(this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_CREATE'))

				this.enableButton = Boolean(permissionToCreate || this.isAdmin)
				this.moduleSchedule = 'demand'
				this.selectDemand(this.demand[0].idMongo)
			}
		}

		await this.checkCompanyStatus()

		if (!this.companyIsActive || (!this.demand && !this.inventorys)) {
			this.notificationService.notify('Demanda não encontrada', 420)
			localStorage.removeItem('demand')
			localStorage.removeItem('cameFromScheduleMap')
			this.router.navigate(['/panel/scheduler'])
		}

		await this.getPinsFromMaps()
		await this.fetchRegions()

		setTimeout(() => {
			this.initMap()
		}, 200)
	}

	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string =
				await this.companyService.checkStatus(this.companyId).toPromise()

			if (companyStatus === 'ACTIVE') {
				this.companyIsActive = true

				return
			}
			this.companyIsActive = false

		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async getPinsFromMaps(): Promise<void> {
		this.allPinsFromMaps =
			await this.schedulingService.getAllPinsSchedulingSteps(this.companyId).toPromise()
	}

	public initMap(): void {

		const iconBase: string = 'assets/images/'
		let iconsLabel: Object = {}
		let mapView: HTMLDivElement

		if (this.openTab1) {
			mapView = document.getElementById('map-principal') as HTMLDivElement

			iconsLabel = {
				minhaDemanda: {
					icon: `${iconBase}m1.svg`,
					name: 'AGENDAMENTO'
				},
				arvore: {
					icon: `${iconBase}m3.svg`,
					name: 'ÁRVORES'
				},
				arvoreSelected: {
					icon: `${iconBase}m3s.svg`,
					name: 'ÁRVORES ATRIBUÍDAS'
				}
			}
		} else if (this.openTab2) {
			mapView = document.getElementById('map-secundario') as HTMLDivElement

			iconsLabel = {
				minhaDemanda: {
					icon: `${iconBase}m1.svg`,
					name: 'AGENDAMENTO'
				},
				arvore: {
					icon: `${iconBase}m2.svg`,
					name: 'AVALIAÇÕES AGENDADAS'
				}
			}
		}

		let lat: number = 0
		let lng: number = 0

		if (this.moduleSchedule == 'inventory') {
			lat = this.inventorys[0].lat
			lng = this.inventorys[0].lng
		} else {
			lat = this.demand[0].lat
			lng = this.demand[0].lng
		}

		const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 16,
			center: new google.maps.LatLng(
				lat,
				lng
			)
		})

		map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [
						{ visibility: 'off' }
					]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [
						{ visibility: 'off' }
					]
				}
			]
		})

		this.myMap = map

		google.maps.event.addListenerOnce(map, 'idle', async () => {
			this.addMarkers(map)
		})

		// Legenda
		const legend = document.createElement('div')
		legend.setAttribute('id', 'legend')

		for (const key in iconsLabel) {
			const type = iconsLabel[key]
			const name = type.name
			const icon = type.icon

			const legendItem = document.createElement('div')
			legendItem.setAttribute('class', 'legend-item')
			legendItem.innerHTML = `<img src="${icon}">
										<span>${name}
									</span>`
			legend.appendChild(legendItem)
		}

		map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend)

		if (this.allRegions.length > 0) {
			this.insertShowRegionsButtonInGooleMaps()
			this.createAllRegions()
			this.showAllRegionsInMap()
		}

		map.addListener('click', () => {
			this.regionInfoWindow.close()
		})

		this.insertGroupPinsButtonInGoogleMaps()

		if (this.openTab1 && this.treeSelected) {
			this.insertControlRetractMap()
		}
	}

	public addMarkers(map: google.maps.Map) {

		const features: any = []
		const iconBase: string = 'assets/images/'

		if (this.markers != undefined) {
			for (let i = 0; i < this.markers.length; i++) {
				this.markers[i].setMap(null)
			}
			this.markers.length = 0
		}

		//delete marker cluster
		if (this.markerCluster != undefined) {
			this.markerCluster.clearMarkers()
		}

		// SELECTED DEMAND
		if (this.moduleSchedule == 'inventory') {
			for (const data of this.inventorys) {
				features.push({
					position: new google.maps.LatLng(
						data.lat,
						data.lng
					),
					type: 'minhaDemanda',
					idMongo: data.idMongo,
					identification: data.identification
				})
			}
		} else if (this.moduleSchedule == 'demand') {
			for (const data of this.demand) {
				features.push({
					position: new google.maps.LatLng(
						data.lat,
						data.lng
					),
					type: 'minhaDemanda',
					idMongo: data.idMongo,
					identification: data.protocol
				})
			}
		}

		const icons: any = {
			minhaDemanda: {
				icon: {
					url: `${iconBase}m1.png`,
					origin: new google.maps.Point(0, 0)
				},
				name: 'SOLICITAÇÃO'
			},
			avaliacao: {
				icon: {
					url: `${iconBase}m2.png`,
					origin: new google.maps.Point(0, 0),
					labelOrigin: new google.maps.Point(21, 19)
				},
				name: 'AVALIAÇÃO AGENDADA'
			},
			arvore: {
				icon: {
					url: `${iconBase}m3.png`,
					origin: new google.maps.Point(0, 0),
					labelOrigin: new google.maps.Point(21, 19)
				},
				name: 'ÁRVORE AVALIADA'
			}
		}

		// TREES
		if (this.allPinsFromMaps.trees.length > 0 && this.openTab1) {
			this.allPinsFromMaps.trees.forEach(tree => {
				features.push({
					position: new google.maps.LatLng(
						tree.lat,
						tree.lng
					),
					treeId: tree.idMongo,
					type: 'arvore',
					identification: tree.identification
				})
			})
		}

		// APPRAISALS
		if (this.allPinsFromMaps.appraisals.length > 0 && this.openTab2) {
			this.allPinsFromMaps.appraisals.forEach(appraisalObj => {
				features.push({
					position: new google.maps.LatLng(
						appraisalObj.lat,
						appraisalObj.lng
					),
					type: 'avaliacao',
					appraisalId: appraisalObj.idMongo
				})
			})
		}

		// Seting Markers
		features.forEach((feature, index) => {

			if (feature.demandsSize > 1) {
				icons.avaliacao.count = `${feature.demandsSize}`
			}

			const infowindow: google.maps.InfoWindow = new google.maps.InfoWindow({
				content: `<div class="labelPin">${feature.identification}</div>`,
				disableAutoPan: true
			})

			let infoWindowOpen: boolean = false

			const showIndividualPins = Boolean(!this.viewMarkersClusterided)

			const marker: google.maps.Marker = new google.maps.Marker({
				position: feature.position,
				map: showIndividualPins ? map : null,
				icon: icons[feature.type].icon,
				title: String(feature.identification)
			})

			this.markers.push(marker)

			if (feature.type === 'avaliacao' && feature.type !== 'arvore') {
				marker.setTitle(null)
				google.maps.event.addListener(marker, 'click', () => {
					this.openModalAgrupar(feature.appraisalId)
				})
			}

			if (feature.type === 'arvore' && feature.type !== 'avaliacao') {
				google.maps.event.addListener(marker, 'click', async () => {
					await this.selectTree(feature.treeId)
					this.switchRetractMap(true)
					this.treeSelectedMarkerIndex = index
					if (infoWindowOpen) {
						infowindow.close()
						infoWindowOpen = false
					} else {
						infowindow.open(map, marker)
						infoWindowOpen = true
					}
				})
			}

			if (feature.type === 'minhaDemanda' && feature.type !== 'arvore' && feature.type !== 'avaliacao') {
				google.maps.event.addListener(marker, 'click', () => {
					this.selectDemand(feature.idMongo)
					if (infoWindowOpen) {
						infowindow.close()
						infoWindowOpen = false
					} else {
						infowindow.open(map, marker)
						infoWindowOpen = true
					}
				})
			}
		})

		if (this.viewMarkersClusterided) {
			this.markerCluster = new MarkerClusterer(this.myMap,
				this.markers,
				this.options
			)

			console.log('Mapa clusterizado')
		} else {
			console.log('Mapa não clusterizado')
		}

		this.isLoading = false
		this.modifyMarkerToSelected()
	}

	public insertGroupPinsButtonInGoogleMaps() {
		const iconBase: string = 'assets/images/icon/group-pin-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.viewMarkersClusterided = !this.viewMarkersClusterided

			this.addMarkers(this.myMap)

			this.setShowOnlySelectButtonActive('group-pin-button')
		}

		button.setAttribute('class', 'btn-google-maps regions-button with-balloon')
		button.setAttribute('id', 'group-pin-button')
		button.appendChild(svgIcon)

		const ballonBase: string = 'assets/images/balloon-group.svg'
		const ballon = document.createElement('img')
		ballon.style.display = 'none'

		ballon.setAttribute('src', ballonBase)

		const divContent = document.createElement('div')
		divContent.setAttribute('class', 'conteiner-button')

		divContent.appendChild(ballon)
		divContent.appendChild(button)

		button.addEventListener('mouseover', () => {
			ballon.style.display = 'block'
		})

		button.addEventListener('mouseout', () => {
			ballon.style.display = 'none'
		})

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(divContent)
	}

	public setShowOnlySelectButtonActive(
		buttonId: 'group-pin-button'
	) {
		const onlySelectButton: HTMLButtonElement =
			document.getElementById(buttonId) as HTMLButtonElement

		if (!onlySelectButton) return

		if (buttonId == 'group-pin-button') {

			if (this.viewMarkersClusterided) {
				onlySelectButton.classList.add('active')
			} else {
				onlySelectButton.classList.remove('active')
			}
		}
	}


	public switchRetractMap(selectingTree: boolean) {
		if (selectingTree) {
			this.retractMap = true
		} else {
			this.retractMap = !this.retractMap
		}

		this.insertControlRetractMap()
	}

	public insertControlRetractMap() {
		const iconBase: string = this.retractMap ?
			'assets/images/icon/arowLeft-icon.svg' : 'assets/images/icon/arowRight-icon.svg'

		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.switchRetractMap(false)
		}

		button.setAttribute('class', 'btn-google-maps schedule-step-one')
		button.setAttribute('id', 'my-button-schedule-step-one')
		button.appendChild(svgIcon)

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.TOP_RIGHT].clear()
		this.myMap.controls[google.maps.ControlPosition.TOP_RIGHT].push(button)
	}

	public modifyMarkerToSelected() {
		const treeMarkersSelected: Array<number> = []

		if (this.moduleSchedule == 'demand') {
			this.demand.forEach(demand => {
				if (demand.markerIndex) {
					treeMarkersSelected.push(demand.markerIndex)
				}
			})
		} else {
			this.inventorys.forEach(inventorys => {
				if (inventorys.markerIndex) {
					treeMarkersSelected.push(inventorys.markerIndex)
				}
			})
		}

		this.markersIndexAssigns.forEach(index => {
			if (treeMarkersSelected.includes(index)) {
				this.markers[index].setIcon({
					url: 'assets/images/m3s.png'
				})
			} else {
				this.markers[index].setIcon({
					url: 'assets/images/m3.png'
				})
			}
		})

		this.markersIndexAssigns = treeMarkersSelected
	}

	public openTabOne() {
		this.openTab1 = true
		this.openTab2 = false
		this.isLoading = true

		setTimeout(() => {
			this.initMap()
		}, 200)
	}

	public async openTabTwo(date?: any): Promise<void> {
		this.openTab1 = false
		this.openTab2 = true
		this.isLoading = true

		setTimeout(() => {
			this.initMap()
		}, 200)

		try {
			const idLastEvaluatorSelected =
				this.evaluatorSelected ? this.evaluatorSelected.id_evaluator : null

			this.evaluatorSelected = null

			if (date) {
				this.current_day = date
			} else {
				this.current_day = moment_().format('YYYY-MM-DD HH:mm:ss.SSS')
			}

			await this.getEvaluators(this.current_day)

			if (this.evaluators && this.evaluators.length > 0) {

				let lastEvaluatorSelected

				if (idLastEvaluatorSelected) {
					lastEvaluatorSelected = this.evaluators.find(evaluator =>
						evaluator.id_evaluator == idLastEvaluatorSelected
					)
				}

				if (lastEvaluatorSelected) {
					this.evaluatorSelected = lastEvaluatorSelected
					this.selectEvaluator(this.evaluatorSelected)
				} else {
					this.evaluators[0].checked = true
					this.evaluatorSelected = this.evaluators[0]
				}

			} else {
				this.evaluatorSelected = null
			}
		} catch (error) {
			console.log(error)
		}
	}

	public async backScheduler(): Promise<void> {
		if (this.moduleSchedule == 'inventory') {
			this.goSchedulerInventory()
		} else {
			this.goScheduler()
		}
	}

	public async goScheduler(): Promise<void> {
		localStorage.removeItem('demand')
		localStorage.removeItem('cameFromScheduleMap')
		this.router.navigate(['/panel/appraisal/scheduler'])
	}

	public async goSchedulerInventory(): Promise<void> {
		localStorage.removeItem('inventorys')
		localStorage.removeItem('cameFromScheduleMap')
		this.router.navigate(['/panel/inventory/schedulerInventory'])
	}

	public changeDate(event: MatDatepickerInputEvent<Date>) {
		try {
			const date = moment_(event.value).format('YYYY-MM-DD HH:mm:ss.SSS')
			this.current_day = date
			this.openTabTwo(this.current_day)
		} catch (error) {
			this.current_day = ''
		}
	}

	public async getEvaluators(date: string): Promise<void> {

		const data = this.moduleSchedule == 'demand' ?
			this.demand[0] : this.inventorys[0]

		try {
			this.evaluators = new Array()

			const response: any =
				await this.schedulingService.getEvaluators(data, date, this.companyId).toPromise()

			this.evaluators = response
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async selectEvaluator(evaluator: RankingEvaluator): Promise<void> {
		this.evaluatorSelected = evaluator
		this.evaluators.forEach(evalua => {
			if (evalua.id_evaluator === this.evaluatorSelected.id_evaluator) {
				evalua.checked = true
			}
		})
	}

	public async openModalAgrupar(appraisalId: string): Promise<void> {
		if (this.appraisalSelected === undefined || this.appraisalSelected.idMongo !== appraisalId) {

			this.appraisalSelected =
			await this.schedulingService.getAppraisalScheduleDetails(appraisalId).toPromise()

			this.carousels.group.pages = this.appraisalSelected.media.length

			const initDay = new Date().setHours(0, 0, 0, 0)
			const scheduleDateFormat = moment_(this.appraisalSelected.schedulingDate, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)

			this.enableGroupButton = Boolean(
				new Date(scheduleDateFormat) >= new Date(initDay)
			)
		}

		this.openAgrupar = true
	}

	public closeModalAgrupar(): void {
		this.openAgrupar = false
		this.carousels.group.arrowLeftEnable = false
	}

	public async selectTree(treeId: string): Promise<void> {
		if (this.treeSelected !== undefined && this.treeSelected.idMongo === treeId) return

		this.treeSelected =
			await this.schedulingService.getTreeEvaluatedDetails(treeId).toPromise()

		this.treeSelected.mediaSelected = this.treeSelected.media[0]
		this.carousels.tree.pages = this.treeSelected.media.length - 1

		this.enableOrDesableButtonAssignTree()
	}

	public enableOrDesableButtonAssignTree() {
		if (this.moduleSchedule == 'demand') {
			this.enablebuttonAssignTree = !Boolean(
				this.demand.some(demand => demand.tree_id == this.treeSelected.idMongo)
			)
		} else {
			this.enablebuttonAssignTree = !Boolean(
				this.inventorys.some(demand => demand.tree_id == this.treeSelected.idMongo)
			)
		}
	}

	public selectDemand(idMongo: string) {
		if (this.moduleSchedule == 'demand') {
			const demandSelected: ListDemandSchedule =
				this.demand.find(demand => demand.idMongo == idMongo)

			this.demandSelected = {
				idMongo: demandSelected.idMongo,
				identification: demandSelected.protocol,
				problems: demandSelected.problems,
				media: demandSelected.media,
				mediaSelected: demandSelected.media[0],
				treeIdentification: (demandSelected.treeId && String(demandSelected.treeId) !== '-') && demandSelected.treeId
			}
		} else {
			const inventorySelect: InventoryScheduleList =
				this.inventorys.find(inventory => inventory.idMongo == idMongo)

			this.demandSelected = {
				idMongo: inventorySelect.idMongo,
				identification: inventorySelect.identification,
				media: inventorySelect.media,
				mediaSelected: inventorySelect.media[0],
				treeIdentification: (inventorySelect.treeId && String(inventorySelect.treeId) !== '-') && inventorySelect.treeId
			}
		}

		this.carousels.demand.pages = this.demandSelected.media.length - 1
	}

	public insertAtribuation(idMongo: string) {
		if (this.moduleSchedule == 'demand') {
			const indexDemand: number =
				this.demand.findIndex(demand => demand.idMongo == idMongo)

			this.demand[indexDemand].tree_id = this.treeSelected.idMongo
			this.demand[indexDemand].treeId = this.treeSelected.identification
			this.demand[indexDemand].markerIndex = this.treeSelectedMarkerIndex
		} else {
			const indexInventory: number =
				this.inventorys.findIndex(inventory => inventory.idMongo == idMongo)

			this.inventorys[indexInventory].tree_id = this.treeSelected.idMongo
			this.inventorys[indexInventory].treeId = this.treeSelected.identification
			this.inventorys[indexInventory].markerIndex = this.treeSelectedMarkerIndex
		}

		this.demandSelected.treeIdentification = this.treeSelected.identification
		this.demandSelected.treeId = this.treeSelected.idMongo
		this.enablebuttonAssignTree = false
		this.markersIndexAssigns.push(this.treeSelectedMarkerIndex)

		this.modifyMarkerToSelected()
	}

	public removeAtribuation(idMongo: string) {
		if (this.moduleSchedule == 'demand') {
			const indexDemand: number =
				this.demand.findIndex(demand => demand.idMongo == idMongo)

			this.demand[indexDemand].tree_id = null
			this.demand[indexDemand].treeId = null
			this.demand[indexDemand].markerIndex = null
		} else {
			const indexInventory: number =
				this.inventorys.findIndex(inventory => inventory.idMongo == idMongo)

			this.inventorys[indexInventory].tree_id = null
			this.inventorys[indexInventory].treeId = null
			this.inventorys[indexInventory].markerIndex = null
		}

		this.demandSelected.treeIdentification = null
		this.modifyMarkerToSelected()
	}

	public moveCarousel(
		direction: 'left' | 'right',
		carroselType: 'demand' | 'tree' | 'group'
	) {
		const carousel = document.getElementById(`carousel-content-${carroselType}`) as HTMLDivElement
		const carouselWidth: number =
			Boolean(carroselType == 'group') ? 250 : 160

		if (direction == 'left') {
			if (this.carousels[carroselType].pageNow > 1) {
				this.carousels[carroselType].pageNow--
			}
		}
		if (direction == 'right') {
			if (this.carousels[carroselType].pageNow < this.carousels[carroselType].pages) {
				this.carousels[carroselType].pageNow++
			}
		}

		if (this.carousels[carroselType].pageNow > 1) {
			this.carousels[carroselType].arrowLeftEnable = true
		} else {
			this.carousels[carroselType].arrowLeftEnable = false
		}

		if (this.carousels[carroselType].pageNow == this.carousels[carroselType].pages) {
			this.carousels[carroselType].arrowRightEnable = false
		} else {
			this.carousels[carroselType].arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carousels[carroselType].pageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public selectPhotoFromDemand(media: string) {
		this.demandSelected.mediaSelected = media
	}

	public selectPhotoFromTree(media: string) {
		this.treeSelected.mediaSelected = media
	}

	public openClosePhotoFromCarousel(media?: string) {
		if (media) {
			this.photoFromCarouselEnable = true
			this.mediaUrlSelected = media
		} else {
			this.photoFromCarouselEnable = false
		}
	}

	// Agrupamento de agendamento de demandas AKI
	public async groupDemand(): Promise<void> {
		try {
			const dataAssignDemand = this.demand.map(data => {
				if (this.moduleSchedule == 'demand') {
					return {
						...data,
						evaluator_id: this.appraisalSelected.evaluator.idMongo,
						demand_id: data.idMongo,
						current_day:
							moment_(this.appraisalSelected.schedulingDate, 'DD/MM/YYYY')
								.add(new Date().getHours(), 'hours')
								.utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
						loggedUser: this.sessionUser._id,
						date: new Date()
					}
				} else {
					return {
						...data,
						current_day: this.current_day,
						loggedUser: this.sessionUser._id,
						evaluator_id: this.evaluatorSelected.id_evaluator,
						date: new Date()
					}
				}
			})

			await this.schedulingService.assignDemand(dataAssignDemand).toPromise()
			this.closeModalAgrupar()
			this.notificationService.notify(
				'Sua solicitação foi agrupada com sucesso!',
				200
			)
			this.goScheduler()
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async changeDay(opt: string): Promise<void> {
		let changedDay: any
		if (opt === 'next') {
			changedDay = moment_(this.current_day)
				.add(1, 'd')
				.format('YYYY-MM-DD 08:00:00.000')
		} else if (opt === 'last') {
			changedDay = moment_(this.current_day)
				.subtract(1, 'd')
				.format('YYYY-MM-DD 08:00:00.000')
		}
		this.openTabTwo(changedDay)
	}

	public async scheduleAvaliation(): Promise<void> {
		try {

			let dataAssignDemand

			if (this.moduleSchedule == 'demand') {
				dataAssignDemand = this.demand.map(data => {
					return {
						...data,
						evaluator_id: this.evaluatorSelected.id_evaluator,
						demand_id: data.idMongo,
						current_day: this.current_day,
						loggedUser: this.sessionUser._id,
						date: new Date(),
						company: this.companyId
					}
				})
			} else {
				dataAssignDemand = this.inventorys.map(data => {
					return {
						...data,
						current_day: this.current_day,
						loggedUser: this.sessionUser._id,
						evaluator_id: this.evaluatorSelected.id_evaluator,
						date: new Date(),
						address: {
							stree: data.address,
							lat: data.lat,
							lng: data.lng
						},
						_id: data.idMongo,
						company: this.companyId
					}
				})
			}


			const response: any = await this.schedulingService
				.assignDemand(
					dataAssignDemand
				)
				.toPromise()
			this.notificationService.notify(response.message, 200)


			localStorage.removeItem('demand')
			localStorage.removeItem('inventories')
			localStorage.removeItem('cameFromScheduleMap')
			if (this.moduleSchedule == 'demand') {
				this.router.navigate(['/panel/appraisal/scheduler'])
			} else {
				this.router.navigate(['/panel/inventory/schedulerInventory'])
			}
		} catch (err) {
			console.log(err)
		}
	}

	public async fetchRegions() {
		try {
			this.allRegions =
				await this.regionsService.getRegionsFromMapByCompanyId(this.companyId).toPromise()
		} catch (err) { }
	}

	public insertShowRegionsButtonInGooleMaps() {
		const iconBase: string = 'assets/images/icon/hide-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('id', 'img-show-all-regions')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.viewAllRegionsInMap = !this.viewAllRegionsInMap
			this.switchShowHideRegionsInMap()
			this.updateImageButtonShowHideRegions()
		}

		button.setAttribute('class', 'btn-google-maps regions-button')
		button.appendChild(svgIcon)

		button.addEventListener('click', () => {
			handleClickButton()
		})

		this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
	}

	public createAllRegions() {
		this.allRegions.forEach(region => {
			const polygon = new google.maps.Polygon({
				strokeOpacity: 0.6,
				strokeWeight: 2,
				fillColor: region.color,
				fillOpacity: 0.5,
				paths: region.coordinates
			})

			polygon.addListener('click', event => {
				const clickLatLng = event.latLng

				if (!this.regionInfoWindow) {
					this.regionInfoWindow = new google.maps.InfoWindow()
				}

				this.regionInfoWindow.setContent(region.name)
				this.regionInfoWindow.setPosition(clickLatLng)
				this.regionInfoWindow.open(this.myMap)
			})

			this.polygonsDelimitAllRegions.push(polygon)
		})
	}

	public switchShowHideRegionsInMap() {
		if (this.viewAllRegionsInMap) {
			this.showAllRegionsInMap()
		} else {
			this.hideAllRegionsInMap()
		}
	}

	public showAllRegionsInMap() {
		this.polygonsDelimitAllRegions.forEach(poligon => {
			poligon.setMap(this.myMap)
		})
	}

	public hideAllRegionsInMap() {
		this.polygonsDelimitAllRegions.forEach(poligon => {
			poligon.setMap(null)
		})

		this.regionInfoWindow.close()
	}

	public updateImageButtonShowHideRegions() {
		const iconBase: string =
			`assets/images/icon/${this.viewAllRegionsInMap ? 'hide-icon' : 'show-icon'}.svg`

		const imageButton: HTMLImageElement =
			document.getElementById('img-show-all-regions') as HTMLImageElement

		if (imageButton) {
			imageButton.setAttribute('src', iconBase)
		}
	}
}
